import { useEffect, useState } from 'react';
import classnames from 'classnames';

import InstructionalVideo from '../../components/InstructionalVideo';
import useHeader from '../../hooks/useHeader';
import useToggleTheme from '../../hooks/useToggleTheme';
import Logo from './components/Logo';
import MenuSideBar from './components/MenuSideBar';
import MobileHamburger from './components/MobileHamburger';
import RightHeader from './components/RightHeader';
import SearchInput from './components/SearchInput';
import NotificationModal from './components/NotificationModal';
import { isFeature } from '../../utils/helpers';

const Header = () => {
  const {
    accountInformationData,
    selectedModal,
    setSelectedModal,
    isSubmitReportFormLoading,
    reportFormik,
    handleCloseReportModal,
    isSubmitFeedbackFormLoading,
    feedbackFormik,
    handleCloseFeedbackModal,
    isSubmitSupportFormLoading,
    supportFormik,
    handleCloseSupportModal,
    saveMessage,
    handleCloseFinishModal,
    submitMessage,
    listCompanies,
    openInstructionalVideo,
    handleCloseInstructionalVideo,
    handleOpenInstructionalVideo,
    tickers,
    saveNotificationOptions,
    isAccountInformationLoading,
  } = useHeader();
  const { isDarkMode } = useToggleTheme();
  const [isMenuSideBarOpen, setIsMenuSideBarOpen] = useState(false);

  useEffect(() => {
    if (document.location.hash === '#iframe') {
      setTimeout(() => {
        const header = document.getElementById('header');
        header?.classList?.add('hidden');
        const mainInsideIframe = document.getElementById('mainContent');
        mainInsideIframe?.classList?.add('mt-0', 'min-h-screen');
        mainInsideIframe?.classList?.remove('min-h-[82vh]');
        document
          .querySelector('#tradingview_a369 iframe')
          ?.classList?.add('min-h-screen');
      }, 2000);
    }
  }, [document.location.hash]);

  if (document.location.hash === '#iframe') {
    return (
      <input type="hidden" id="userId" value={accountInformationData?.userId} />
    );
  }

  const isDerivativePage = () => {
    const stockID = window.location.pathname.split('/')[1];
    if (
      isFeature(stockID) ||
      stockID.toLowerCase() === 'chung-khoan-phai-sinh'
    ) {
      return true;
    }
    return false;
  };

  return (
    <header
      className={classnames(
        'z-[200] py-4 ',
        document.location.pathname.indexOf('/stockup-ai') === -1 && document.location.pathname !== "/"
          ? 'bg-white shadow-md dark:bg-gray-800'
          : ''
      )}
    >
      <div className="flex items-center justify-between h-full px-4 mx-auto text-black dark:text-white">
        <MobileHamburger
          setIsMenuSideBarOpen={setIsMenuSideBarOpen}
          handleOpenInstructionalVideo={handleOpenInstructionalVideo}
          tickers={tickers}
          accountInformationData={accountInformationData}
          saveNotificationOptions={saveNotificationOptions}
          isAccountInformationLoading={isAccountInformationLoading}
        />
        <Logo isDarkMode={isDarkMode} />
        <div className="w-1/3 sm:w-2/4 lg:w-2/5 flex items-center justify-end">
          {document.location.pathname.indexOf('/stockup-ai') === -1 && document.location.pathname !== "/" ? (
            <SearchInput listCompanies={listCompanies} tickers={tickers} />
          ) : null}
          <RightHeader
            isDarkMode={isDarkMode}
            accountInformationData={accountInformationData}
          />
        </div>
      </div>
      <MenuSideBar
        isDarkMode={isDarkMode}
        selectedModal={selectedModal}
        setSelectedModal={setSelectedModal}
        isMenuSideBarOpen={isMenuSideBarOpen}
        setIsMenuSideBarOpen={setIsMenuSideBarOpen}
        isSubmitReportFormLoading={isSubmitReportFormLoading}
        reportFormik={reportFormik}
        handleCloseReportModal={handleCloseReportModal}
        isSubmitFeedbackFormLoading={isSubmitFeedbackFormLoading}
        feedbackFormik={feedbackFormik}
        handleCloseFeedbackModal={handleCloseFeedbackModal}
        isSubmitSupportFormLoading={isSubmitSupportFormLoading}
        supportFormik={supportFormik}
        handleCloseSupportModal={handleCloseSupportModal}
        saveMessage={saveMessage}
        handleCloseFinishModal={handleCloseFinishModal}
        submitMessage={submitMessage}
        isLogin={!!accountInformationData?.userId}
      />
      {accountInformationData?.userId &&
      document.location.hash !== '#iframe' &&
      !isDerivativePage() ? (
        <NotificationModal />
      ) : null}
      <InstructionalVideo
        open={openInstructionalVideo}
        onClose={handleCloseInstructionalVideo}
      />
    </header>
  );
};

export default Header;
